<template>
  <div class="setting-main-container">
      <div class="card setting-card">
        <div class="page-header">
          <h3 class="page-title">{{ $t('accounts.basic_info') }}</h3>
        </div>
        <div class="row">
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('accounts.display_name') }}</label>
            <p v-if="viewAccount && viewAccount.name !=null">{{ viewAccount.name }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('accounts.primary_contact_name') }}</label>
            <p v-if="viewAccount && viewAccount.contact_name !=null">{{ viewAccount.contact_name }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('accounts.company_name') }}</label>
            <p v-if="viewAccount  && viewAccount.company_name!=null">{{ viewAccount.company_name}}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('accounts.phone') }}</label>
            <p v-if="viewAccount && viewAccount.phone !=null">{{ viewAccount.phone }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('accounts.email') }}</label>
            <p v-if="viewAccount && viewAccount.email !=null">{{ viewAccount.email }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('accounts.website') }}</label>
            <p v-if="viewAccount && viewAccount.website !=null">{{ viewAccount.website }}</p>
          </div>

          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('accounts.primary_currency') }}</label>
            <p v-if="viewAccount && viewAccount.currency !=null">{{ viewAccount.currency.code }}-{{ viewAccount.currency.name }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('accounts.role') }}</label>
            <p v-if="viewAccount && viewAccount.role !=null">{{ viewAccount.role.toUpperCase() }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('accounts.status') }}</label>
            <p v-if="viewAccount && viewAccount.status !=null">{{ viewAccount.status.toUpperCase() }}</p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('accounts.account_type') }}</label>
            <p v-if="viewAccount && viewAccount.account_type !=null">{{ viewAccount.account_type.toUpperCase() }}</p>
          </div>
        </div>
        <div v-if="viewAccount && viewAccount.account_type !=null && viewAccount.account_type ==='funder' && auditInfo">
          <div class="page-header">
          <h3 class="page-title">{{ $t('general.auditor_info') }}</h3>
        </div>
        <div class="row">
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('accounts.display_name') }}</label>
            <p v-if="viewAccount &&
              viewAccount.user &&
              viewAccount.user.funder_link_audit_account &&
              viewAccount.user.funder_link_audit_account. audit_account &&
              viewAccount.user.funder_link_audit_account. audit_account.name !=null">
              {{ viewAccount.user.funder_link_audit_account. audit_account.name }}
            </p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('accounts.primary_contact_name') }}</label>
            <p v-if="viewAccount &&
              viewAccount.user &&
              viewAccount.user.funder_link_audit_account &&
              viewAccount.user.funder_link_audit_account. audit_account &&
              viewAccount.user.funder_link_audit_account. audit_account.account &&
              viewAccount.user.funder_link_audit_account. audit_account.account.contact_name !=null">
              {{ viewAccount.user.funder_link_audit_account. audit_account.account.contact_name }}
            </p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('accounts.company_name') }}</label>
            <p v-if="viewAccount &&
              viewAccount.user &&
              viewAccount.user.funder_link_audit_account &&
              viewAccount.user.funder_link_audit_account. audit_account &&
              viewAccount.user.funder_link_audit_account. audit_account.company !=null">
              {{ viewAccount.user.funder_link_audit_account. audit_account.company.name }}
            </p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('accounts.phone') }}</label>
            <p v-if="viewAccount &&
              viewAccount.user &&
              viewAccount.user.funder_link_audit_account &&
              viewAccount.user.funder_link_audit_account. audit_account &&
              viewAccount.user.funder_link_audit_account. audit_account.company &&
              viewAccount.user.funder_link_audit_account. audit_account.company.phone !=null">
              {{ viewAccount.user.funder_link_audit_account. audit_account.company.phone }}
            </p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('accounts.email') }}</label>
            <p v-if="viewAccount &&
              viewAccount.user &&
              viewAccount.user.funder_link_audit_account &&
              viewAccount.user.funder_link_audit_account.audit_account &&
              viewAccount.user.funder_link_audit_account.audit_account.email !=null">
              {{ viewAccount.user.funder_link_audit_account.audit_account.email }}
            </p>
          </div>
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('accounts.website') }}</label>
            <p v-if="viewAccount &&
            viewAccount.user &&
              viewAccount.user.funder_link_audit_account &&
              viewAccount.user.funder_link_audit_account. audit_account &&
              viewAccount.user.funder_link_audit_account.audit_account.account &&
              viewAccount.user.funder_link_audit_account.audit_account.account.website
              ">
              {{ viewAccount.user.funder_link_audit_account. audit_account.account.website }}
            </p>
          </div>
        </div>
        </div>

        <div v-if="viewAccount && viewAccount.account_type !=null && viewAccount.account_type ==='funder' && formInfo">
          <div class="page-header">
          <h3 class="page-title">{{ $t('general.form_info') }}</h3>
        </div>
        <div class="row">
          <div class="col-md-6 mb-4">
            <label class="form-label">{{ $t('accounts.display_name') }}</label>
            <p v-if="viewAccount &&
              viewAccount.user &&
              viewAccount.user.funder_islamic_form &&
              viewAccount.user.funder_islamic_form. islamic_form &&
              viewAccount.user.funder_islamic_form. islamic_form.name !=null">
              {{ viewAccount.user.funder_islamic_form. islamic_form.name }}
            </p>
          </div>

        </div>
        </div>
      </div>
  </div>
</template>
<script>

import { validationMixin } from 'vuelidate'
import { mapActions,mapGetters } from 'vuex'
const { required, email, maxLength, numeric } = require('vuelidate/lib/validators')

export default {
  mixins: [validationMixin],
  data () {
    return {
        isLoading: false,
        auditInfo:false,
        formInfo:false
    }
  },
  computed: {
    ...mapGetters('account', [
      'viewAccount'
    ]),
  },
  created() {
    if(localStorage.getItem('role')=='super_admin'){
      this.auditInfo = true
      this.formInfo = true
    }
  },
  validations: {},
  mounted () {},
  methods: {}
}
</script>
